import api from "./Api";

export interface ICartaoAnexo {
    id: number;
    cartaoId: number;
    nomeOriginal: string;
    contentType: string;
    tamanhoBytes: number;
    dataCriacao: string;
    url?: string | null;
}

// DEVN3-604 — mesmas regras de CartaoAnexoService (backend); aqui só para barrar antes do envio.
export const ANEXO_TAMANHO_MAXIMO_BYTES = 10 * 1024 * 1024;
export const ANEXO_QUANTIDADE_MAXIMA = 10;
export const ANEXO_CONTENT_TYPES = ['application/pdf', 'image/png', 'image/jpeg', 'image/jpg', 'image/webp', 'image/gif'];
export const ANEXO_EXTENSOES = ['pdf', 'png', 'jpg', 'jpeg', 'webp', 'gif'];
export const ANEXO_FORMATOS_DESCRICAO = 'PDF, PNG, JPG, JPEG, WEBP ou GIF';

const baseURL = process.env.REACT_APP_API_CORE_URL ?? 'https://api-core.dev.painel-agholmes.com/api/v3/';

class CartaoAnexoService {
    async disponibilidade(cartaoId: number): Promise<boolean> {
        const { data } = await api.get<{ permitido: boolean }>(`Cartao/${cartaoId}/anexos/disponibilidade`, { baseURL });
        return data.permitido;
    }

    async listar(cartaoId: number): Promise<ICartaoAnexo[]> {
        const { data } = await api.get<ICartaoAnexo[]>(`Cartao/${cartaoId}/anexos`, { baseURL });
        return data;
    }

    async anexar(cartaoId: number, arquivo: File): Promise<ICartaoAnexo> {
        const form = new FormData();
        form.append('file', arquivo, arquivo.name);
        const { data } = await api.post<ICartaoAnexo>(`Cartao/${cartaoId}/anexos`, form, {
            baseURL,
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return data;
    }

    async excluir(cartaoId: number, anexoId: number): Promise<void> {
        await api.delete(`Cartao/${cartaoId}/anexos/${anexoId}`, { baseURL });
    }
}

export default new CartaoAnexoService();
